/* ==========================================================================
   SearcherFli > Client > Product > Openjaw > Row > Destination
   ========================================================================== */

/* Modules */
const { addStyle, addData } = require('@bluekiri/alexandria/helpers/dataHelpers');
const { toNode } = require('@bluekiri/alexandria/helpers/domHelpers');

const Autocomplete = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/client/js');
const AutocompleteTemplate = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/template');
/* eslint-disable */
const AutocompleteActions = require('@bluekiri/alexandria-contrib-components/components/autocomplete-rxjs/client/js/store/actions');
/* eslint-enable */

const { DESTINATION } = require('../../../../../../../constants');

const configuration = require('../../../../../config');

function addErrorMessage(instance, index) {
    const { config } = instance;
    const { literals } = config;
    const { errorSameOriginDestination = 'errorSameOriginDestination' } = literals;
    const { destination } = instance.rows[index];

    const node = toNode(`<div class='searcher__error'>${errorSameOriginDestination}</div>`)[0];

    destination.element.appendChild(node);

    setTimeout(() => (destination.element ? destination.element.removeChild(node) : false), 3000);
}

/* Is not like equal origin */
function isNotEqualToOrigin(instance, index) {
    const { origin, destination } = instance.store.select('openjaw').rows[index];

    const { value: originValue } = origin;
    const { value: destinationValue } = destination;

    if (originValue === destinationValue) {
        instance.rows[index].destination.actions.setError();
        addErrorMessage(instance, index);
        return false;
    }

    return true;
}

/* Render destination */
const renderDestination = (destination, literals, context) => {
    /* Literals */
    const { destinationLabel = '' } = literals;

    return AutocompleteTemplate(
        addStyle(
            addData(
                {
                    config: {
                        literals
                    },
                    icon: 'earth-planet',
                    label: destinationLabel,
                    types: DESTINATION.DESTINATION_DEFAULT_TYPES,
                    ...destination
                },
                { type: configuration().type.destination }
            ),
            ['searcher__item']
        ),
        context
    );
};

/* Init */
function initDestination(instance, index) {
    const panel = instance;

    /* Reference */
    panel.rows[index].destination = Autocomplete(
        `${instance.selector} [data-row='${index}'] [data-component=AutocompleteRxjs][data-type=${
            configuration().type.destination
        }]`
    );

    /* Reactions */
    panel.reactions = {
        ...instance.reactions,
        [`change-destination-${index}`]: instance.rows[index].destination.store.subscribe((_, action) => {
            if (action.type !== AutocompleteActions.types.CHANGE_VALUE) return;

            instance.rows[index].destination.actions.resetStatus();
            /* Dispatch */
            instance.actions.changeRow({ destination: action.payload, index });

            if (!isNotEqualToOrigin(instance, index)) {
                /* Dispatch */
                instance.actions.changeRow({ destination: null, index });
                return;
            }

            instance.rows[index].destination.actions.resetStatus();
        }),
        [`clear-destination-${index}`]: instance.rows[index].destination.store.subscribe((_, action) => {
            if (action.type !== AutocompleteActions.types.CLEAR) return;

            /* Dispatch */
            instance.actions.setRow({ destination: null, index });
            instance.rows[index].destination.actions.setError();
        })
    };

    /* Start */
    const { value } = instance.rows[index].destination.store.select('autocomplete');

    /* Sync */
    instance.actions.setRow({ destination: value, index });
}

/* Destroy */
function destroyDestination(instance, index) {
    const panel = instance;

    panel.rows[index].destination.actions.destroy();

    delete panel.rows[index].destination;

    panel.reactions[`change-destination-${index}`].unsubscribe();
    panel.reactions[`clear-destination-${index}`].unsubscribe();
    delete panel.reactions[`change-destination-${index}`];
    delete panel.reactions[`clear-destination-${index}`];
}

/* Exports */
module.exports = {
    renderDestination,
    initDestination,
    destroyDestination
};
